<template>
  <div class="popup-checkin">
    <div class="left">
      <UIButton
        :ghost="true"
        class="editbooking"
        @click="$emit('editBooking')"
      >{{ $t("Edit Reservation") }}</UIButton>
    </div>
    <div class="right">
      <UIButton class="checkin" @click="$emit('checkIn')">{{ $t("Check In") }}</UIButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
  },
})
export default class BookingDetailCheckin extends Vue {}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.popup-checkin {
  @media (--tablet) {
    display: flex;
    align-items: flex-start;
    padding: 0;
  }

  & .left {
    display: flex;
    flex: 1 0 50%;
    align-items: center;
    padding: var(--spacingSm) 0 0 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .editbooking {
      flex: 1 1 auto;
      margin-left: auto;
    }
  }

  & .right {
    display: flex;
    flex: 1 0 50%;
    align-items: center;
    padding: var(--spacingSm) 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .checkin {
      flex: 1 1 15rem;
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-start;

      @media (--tablet) {
        margin-right: var(--spacingSm);
      }
    }
  }
}
</style>
